import { assign } from 'fsm';
import Raven from 'raven-js';
import { enrichList } from './client';
import { usageTracker } from '../../../usageTracker';
export const machine = {
  initial: 'initializing',
  states: {
    initializing: {
      always: [{
        target: 'idle',
        actions: ['trackOpen']
      }],
      tags: ['loading']
    },
    idle: {
      on: {
        ENRICH: 'enrich',
        SET_OVERWRITE: {
          target: 'idle',
          actions: ['setOverwrite']
        }
      }
    },
    enrich: {
      invoke: {
        src: 'enrichList',
        onDone: {
          actions: ['success', 'trackEnrichedRecords']
        },
        onError: {
          target: 'error',
          actions: ['error', 'logError']
        }
      },
      tags: ['loading']
    },
    error: {
      on: {
        ENRICH: 'enrich',
        SET_OVERWRITE: {
          actions: ['setOverwrite']
        }
      }
    }
  },
  on: {
    TOGGLE_ENRICH_ASSOCIATED_RECORDS: {
      actions: ['toggleEnrichAssociations']
    }
  },
  actions: {
    trackOpen: context => {
      usageTracker.track('interaction', {
        action: 'opened-enrichment-list-modal',
        screen: 'enrichment-list-modal',
        subscreen: String(context.listId)
      });
    },
    setOverwrite: assign((_context, event) => {
      return {
        overwrite: event.data.overwrite
      };
    }),
    success: context => {
      context.onSuccess(context.size);
    },
    toggleEnrichAssociations: assign(context => {
      return {
        enrichAssociations: !context.enrichAssociations
      };
    }),
    trackEnrichedRecords: context => {
      usageTracker.track('enriched-record', {
        enrichmentType: 'list',
        objectType: context.objectType,
        selectionType: 'manual',
        propertyCount: 0,
        selectionCount: 0,
        selectionDifference: 0
      });
    },
    error: (context, event) => {
      const {
        responseJSON
      } = event.data;
      const {
        correlationId
      } = responseJSON;
      context.onError(correlationId);
    },
    logError: (_context, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON);
    }
  },
  services: {
    enrichList
  }
};